export default __webpack_public_path__ + "static/media/O-030.5f84c641.png";